import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const LazyForgotPassword = lazy(() =>
  import('./-forgot-password').then((module) => ({ default: module.ForgotPassword })),
);

const ForgotPasswordRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyForgotPassword />
  </Suspense>
);

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordRouteComponent,
});
